// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-068c0ea0]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.text-widget[data-v-068c0ea0]{padding:20px 0}.text-widget.is-mobile[data-v-068c0ea0]{padding:10px}.text-widget.is-mobile .text-box[data-v-068c0ea0]{padding:0 11px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
